module.exports = "/_next/static/images/2b841c79edc63e15815e92a6f74e4306-mulher-com-cachos-maravilhosos-segurando-cartao-lg@2x.jpg.webp";